var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorClickOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 10L8.66661 13.3333L5.99994 6L13.3333 8.66667L9.99994 10ZM9.99994 10L13.3333 13.3333M4.79194 1.49267L5.30994 3.424M3.42394 5.31L1.49194 4.792M9.29994 2.7L7.88528 4.11467M4.11394 7.88533L2.70061 9.3",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorClickOutline);
export default __webpack_public_path__ + "static/media/CursorClickOutline.63999ae657ef6e3d33d1a811eedf44d0.svg";
export { ForwardRef as ReactComponent };